import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { bindActionCreators } from 'redux';
import { InView } from 'react-intersection-observer';
import { deepEqual } from '../../utils';
import { getPartnersApiSelector } from './service/partnersApi/selector';
import { getPartnersApi } from './service/partnersApi/actions';
import CardUnconfigured from '../../Components/PartnerCardNew/CardUnconfigured';
import CardActifInactif from '../../Components/PartnerCardNew/CardActifInactif';
import CardConfiguration from '../../Components/PartnerCardNew/CardConfiguration';

let searchTimeOut;

// Les 3 états d'un partenaire (cf. mediation-front-api getEspaceClientPartners).
// status / step sont portés par partner.onboarding :
//   - step === 'success'          -> configuré
//   - status === 'configuration'  -> en configuration
//   - sinon (status null/disabled, step null/initial) -> non configuré
export const PARTNER_SECTION = {
	CONFIGURING: 'configuring',
	CONFIGURED: 'configured',
	UNCONFIGURED: 'unconfigured',
};

export const getPartnerSection = partner => {
	const onboarding = (partner && partner.onboarding) || {};
	const { status, step } = onboarding;

	if (step === 'success') return PARTNER_SECTION.CONFIGURED;
	if (status === 'configuration') return PARTNER_SECTION.CONFIGURING;
	return PARTNER_SECTION.UNCONFIGURED;
};

class partnersNewModule extends Component {
	constructor(props) {
		super(props);
		this.state = {
			partners: [],
			tags: [],
			tagSelected: '',
			blurBackground: false,
			searchInputActive: false,
			displayInputSearch: false,
			// Partenaire dont on vient de lancer la config (clic "Configurer") :
			// sa card "En configuration" doit s'ouvrir dépliée.
			autoOpenPrefix: '',
			searchText: '',
		};
	}

	// Appelé au clic "Configurer" d'une tuile non configurée : mémorise le prefix
	// pour déplier directement sa future card de configuration.
	handleStartConfiguration = prefix => {
		this.setState({ autoOpenPrefix: prefix });
	};

	componentDidMount() {
		// L'affichage est piloté par la nouvelle route (partners/all → partnersApi).
		this.setState({
			partners: [...this.props.partnersApi],
		});

		// Récupère la liste des partenaires.
		this.props.getPartnersApi();
	}

	componentDidUpdate(prevProps, prevState) {
		if (!deepEqual(prevProps.partnersApi, this.props.partnersApi)) {
			this.setState({
				partners: this.props.partnersApi,
			});
		}

		if (!deepEqual(prevState.partners, this.state.partners)) {
			let tags = this.state.partners.reduce((acc, p) => {
				if (!p) return acc; // blindage
				if (p.type && acc.indexOf(p.type) === -1) {
					acc.push(p.type);
				}
				return acc;
			}, []);
			this.setState({ tags });
		}
	}

	searchBar = e => {
		if (searchTimeOut) {
			clearTimeout(searchTimeOut);
		}
		const value = e.target.value;
		let partnerSearched = this.props.partnersApi.reduce((acc, part) => {
			let partenaire = I18n.t(`partner.prefix.${part.prefix}`);
			// includes() et non search() : search interprète la saisie comme une
			// regex → une saisie type "(" ou "[" ferait planter la recherche.
			if (partenaire.toLowerCase().includes(value.toLowerCase())) {
				acc.push(part);
			}
			return acc;
		}, []);
		searchTimeOut = setTimeout(() => {
			if (!deepEqual(partnerSearched, this.state.partners)) {
				this.setState({
					partners: partnerSearched,
					tagSelected: '',
				});
			}
			this.setState({ searchText: value });
		}, 300);
	};

	setTag = tag => {
		let partnerSearched = [];
		if (tag) {
			partnerSearched = this.props.partnersApi.reduce((acc, part) => {
				if (part.type === tag) {
					acc.push(part);
				}
				return acc;
			}, []);
		} else {
			partnerSearched = [...this.props.partnersApi];
		}
		if (!deepEqual(partnerSearched, this.state.partners)) {
			this.setState({
				partners: partnerSearched,
				tagSelected: tag,
			});
		}
	};

	render() {
		const classNameSearchTag = this.state.blurBackground
			? 'z-index0'
			: 'z-index5';

		let seachBarClass = 'search-bar';
		if (this.state.searchInputActive) {
			seachBarClass += ' search-bar-active';
		}

		// Partenaire à déplier automatiquement : soit un retour de flux externe
		// (?openPartner=… ex. redirect OAuth Ubereats), soit une config qu'on
		// vient de lancer via "Configurer" (autoOpenPrefix). Générique.
		const openPartner =
			new URLSearchParams(window.location.search).get('openPartner') ||
			this.state.autoOpenPrefix;

		// Répartition des partenaires (déjà filtrés par recherche/tag) dans les 3 sections.
		const partnersConfiguring = this.state.partners.filter(
			p => getPartnerSection(p) === PARTNER_SECTION.CONFIGURING
		);
		const partnersConfigured = this.state.partners.filter(
			p => getPartnerSection(p) === PARTNER_SECTION.CONFIGURED
		);
		const partnersUnconfigured = this.state.partners.filter(
			p => getPartnerSection(p) === PARTNER_SECTION.UNCONFIGURED
		);

		return (
			<div className="partners-container">
				<div
					className={seachBarClass}
					onClick={() => {
						this.setState({ searchInputActive: true });
						setTimeout(() => this.setState({ displayInputSearch: true }), 500);
					}}>
					<SearchIcon />
					{this.state.displayInputSearch ? (
						<input
							type="text"
							className="form-control"
							placeholder={I18n.t('partner.search')}
							onKeyUp={e => this.searchBar(e)}
							autoFocus={true}
							onBlur={() => {
								if (!this.state.searchText.length) {
									this.setState({
										searchInputActive: false,
										displayInputSearch: false,
									});
								}
							}}
						/>
					) : null}
				</div>

				<InView threshold={[1]}>
					{({ inView, ref }) => {
						return (
							<React.Fragment>
								<div ref={ref} id="searchTag" />
								<div
									className={
										inView
											? 'search-tag-content ' + classNameSearchTag
											: 'search-tag-content white ' + classNameSearchTag
									}>
									<div className="search-tag-container">
										{this.state.tags.map((t, i) => {
											return (
												<div
													key={i}
													onClick={
														this.state.tagSelected === t
															? null
															: () => this.setTag(t)
													}
													className={
														this.state.tagSelected === t
															? 'tag-container tag-selected'
															: 'tag-container'
													}>
													<p>{t}</p>
													{this.state.tagSelected === t ? (
														<CloseIcon onClick={() => this.setTag('')} />
													) : null}
												</div>
											);
										})}
									</div>
								</div>
							</React.Fragment>
						);
					}}
				</InView>

				{/* 1. En configuration */}
				{partnersConfiguring.length > 0 ? (
					<div>
						<div className="title-content">
							<h2>{I18n.t('partner.configuration_in_progress')}</h2>
						</div>
						<div className="partnerconfig-content-container">
							{partnersConfiguring.map((partner, index) => (
								<CardConfiguration
									key={partner.partner_id || partner.prefix}
									partner={partner}
									index={index}
									autoOpen={!!openPartner && partner.prefix === openPartner}
								/>
							))}
						</div>
					</div>
				) : null}

				{partnersConfiguring.length > 0 && partnersConfigured.length > 0 ? (
					<div className="divider" />
				) : null}

				{/* 2. Configurés */}
				{partnersConfigured.length > 0 ? (
					<div>
						<div className="title-content">
							<h2>{I18n.t('dashboard.partners')}</h2>
						</div>
						<div className="partnerconfig-content-container">
							{partnersConfigured.map(partner => (
								<CardActifInactif
									key={partner.partner_id || partner.prefix}
									partner={partner}
								/>
							))}
						</div>
					</div>
				) : null}

				{partnersUnconfigured.length > 0 &&
				(partnersConfigured.length > 0 || partnersConfiguring.length > 0) ? (
					<div className="divider" />
				) : null}

				{/* 3. Non configurés */}
				{partnersUnconfigured.length > 0 ? (
					<div>
						<div className="title-content">
							<h2>{I18n.t('partner.soon')}</h2>
						</div>
						<div className="partnerconfig-content-container">
							{partnersUnconfigured.map(partner => (
								<CardUnconfigured
									key={partner.partner_id || partner.prefix}
									partner={partner}
									onConfigure={this.handleStartConfiguration}
								/>
							))}
						</div>
					</div>
				) : null}

				{partnersUnconfigured.length === 0 &&
				partnersConfigured.length === 0 &&
				partnersConfiguring.length === 0 ? (
					<div className="no-partner">
						<h2>{I18n.t('partner.no_partner')}</h2>
					</div>
				) : null}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		partnersApi: getPartnersApiSelector(state),
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getPartnersApi: bindActionCreators(getPartnersApi, dispatch),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(partnersNewModule);
